module.exports = __webpack_public_path__ + "img/emp-dir-grid.cffd3d76.svg";